import { useEffect, useRef } from 'react';
import { webSocketService, WebSocketEventType, WebSocketEventHandler } from '../services/websocket.service';

export const useWebSocket = (eventType: WebSocketEventType, handler: WebSocketEventHandler, enabled: boolean = true, userId?: string | null) => {
   const handlerRef = useRef(handler);

   // Keep handler ref up to date
   useEffect(() => {
      handlerRef.current = handler;
   }, [handler]);

   // Set userId when it changes
   useEffect(() => {
      if (enabled && userId) {
         webSocketService.setUserId(userId);
      } else if (!enabled || !userId) {
         webSocketService.setUserId(null);
      }
   }, [userId, enabled]);

   useEffect(() => {
      if (!enabled) {
         return;
      }

      // Create a stable handler that uses the ref
      const stableHandler: WebSocketEventHandler = (event) => {
         handlerRef.current(event);
      };

      // Subscribe to the event
      const unsubscribe = webSocketService.subscribe(eventType, stableHandler);

      // Cleanup on unmount or when disabled
      return () => {
         unsubscribe();
      };
   }, [eventType, enabled]);
};
